import styled from '@emotion/styled';
import isPropValid from '@emotion/is-prop-valid';

// @emotion/is-prop-valid 1.1 doesn't know `fetchpriority` and would strip it from the <img>.
const Image = styled('img', {
  shouldForwardProp: (prop) => prop === 'fetchpriority' || (typeof prop === 'string' && isPropValid(prop)),
})<{
  round?: boolean,
  width?: string,
  height?: string,
  objectFit?: 'fill' | 'contain' | 'cover' | 'none' | 'scale-down',
  maxWidth?: string,
}>(({ theme, round, width, maxWidth = '100%', height, objectFit = 'contain' }) => ({
  width,
  maxWidth,
  height,
  display: 'block',
  objectFit,
  borderRadius: round ? '50%' : theme.radius.default,
}));

export default Image;
